var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapitalLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00004 3.25C5.28412 3.25 5.54382 3.4105 5.67086 3.66459L8.67086 9.66459C8.8561 10.0351 8.70594 10.4856 8.33545 10.6708C7.96497 10.8561 7.51446 10.7059 7.32922 10.3354L6.53652 8.75H3.46357L2.67086 10.3354C2.48562 10.7059 2.03511 10.8561 1.66463 10.6708C1.29415 10.4856 1.14398 10.0351 1.32922 9.66459L4.32922 3.66459C4.45626 3.4105 4.71596 3.25 5.00004 3.25ZM4.21357 7.25H5.78652L5.00004 5.67705L4.21357 7.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 5C10.25 4.58579 10.5858 4.25 11 4.25H22C22.4142 4.25 22.75 4.58579 22.75 5C22.75 5.41421 22.4142 5.75 22 5.75H11C10.5858 5.75 10.25 5.41421 10.25 5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.25C1.58579 14.25 1.25 14.5858 1.25 15C1.25 15.4142 1.58579 15.75 2 15.75H22C22.4142 15.75 22.75 15.4142 22.75 15C22.75 14.5858 22.4142 14.25 22 14.25H2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 10C10.25 9.58579 10.5858 9.25 11 9.25H22C22.4142 9.25 22.75 9.58579 22.75 10C22.75 10.4142 22.4142 10.75 22 10.75H11C10.5858 10.75 10.25 10.4142 10.25 10Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.25C1.58579 19.25 1.25 19.5858 1.25 20C1.25 20.4142 1.58579 20.75 2 20.75H22C22.4142 20.75 22.75 20.4142 22.75 20C22.75 19.5858 22.4142 19.25 22 19.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitalLetter);
export default __webpack_public_path__ + "static/media/capital-letter.5109b8930c52609b990a0c1edb4c70a6.svg";
export { ForwardRef as ReactComponent };